import { render, staticRenderFns } from "./IframeGallery.vue?vue&type=template&id=f2e1f190&"
import script from "./IframeGallery.vue?vue&type=script&lang=ts&"
export * from "./IframeGallery.vue?vue&type=script&lang=ts&"
import style0 from "./IframeGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports